import _ from 'underscore';

import { MapperHelper } from '../../../ts/mappers/MapperHelper';
import { UserMapper } from '../../../ts/mappers/UserMapper';
import { IUserInfo } from '../../../ts/models/IUserInfo';
import { IPredictiveModel, IPredictiveModelDetail } from '../../serverApi/types/IPredictiveModel';
import { IPredictiveModelDetailInfo, IPredictiveModelInfo } from '../IPredictiveModelInfo';

export module PredictiveModelMapper {
  const M = MapperHelper;

  export function map(
    serverApiMetrics: IPredictiveModel[],
    users: _.Dictionary<IUserInfo>,
  ): IPredictiveModelInfo[] {
    return serverApiMetrics.map((m: IPredictiveModel) => {
      return mapOne(m, users[m.ownerId]);
    });
  }

  export function mapOne(
    predictiveModel: IPredictiveModel,
    owner?: IUserInfo,
  ): IPredictiveModelInfo {
    return {
      id: predictiveModel.id,
      name: predictiveModel.name,
      owner: UserMapper.mapOne(owner),
      updatedAt: M.toDate(predictiveModel.updatedAt),
      contentType: 'predictiveModel',
    };
  }

  export function mapDetail(p: IPredictiveModelDetail): IPredictiveModelDetailInfo {
    return {
      id: p.id,
      name: p.name,
      owner: UserMapper.mapOne(p.owner),
      updatedAt: M.toDate(p.updatedAt),
      contentType: 'predictiveModel',
    };
  }
}
